import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "@/assets/logo.webp";
import TopBar from "./TopBar";
import { openNostiumWidget } from "@/lib/nostium";

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/alpacas", label: "Onze Alpaca's" },
    { path: "/activiteiten", label: "Activiteiten" },
    { path: "/over-ons", label: "Over ons" },
    { path: "/samenwerkingen", label: "Samenwerkingen" },
    { path: "/faq", label: "Veelgestelde vragen" },
    { path: "/contact", label: "Contact" },
  ];

  const handleBookingClick = () => {
    setMobileMenuOpen(false);
    openNostiumWidget();
  };

  return (
    <>
      <TopBar />
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-20 items-center justify-between">
          <Link to="/" className="flex items-center group relative z-10">
            <img
              src={logo}
              alt="Alpacaboerderij Dordrecht"
              className="w-auto group-hover:scale-105 transition-transform h-[55px]"
            />
          </Link>

          {/* Desktop Navigation - only on lg+ */}
          <nav className="hidden nav:flex items-center space-x-1">
            {navItems.map((item) => (
              <Button key={item.path} variant={location.pathname === item.path ? "default" : "ghost"} className="font-medium" asChild>
                <Link to={item.path}>
                  {item.label}
                </Link>
              </Button>
            ))}
            <Button
              className="ml-4 bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70"
              onClick={openNostiumWidget}
            >
              Maak je reservering
            </Button>
          </nav>

          {/* Tablet/Mobile: reservation button + hamburger */}
          <div className="flex nav:hidden items-center gap-2">
            <Button
              size="sm"
              className="hidden sm:inline-flex bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70"
              onClick={openNostiumWidget}
            >
              Maak je reservering
            </Button>
            <button className="p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? "Menu sluiten" : "Menu openen"}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile/Tablet Navigation */}
        {mobileMenuOpen && (
          <div className="nav:hidden border-t border-border/40 bg-background/95 backdrop-blur">
            <nav className="container flex flex-col space-y-2 py-4">
              {navItems.map((item) => (
                <Button
                  key={item.path}
                  variant={location.pathname === item.path ? "default" : "ghost"}
                  className="w-full justify-start"
                  asChild
                >
                  <Link to={item.path} onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </Button>
              ))}
              <Button
                className="sm:hidden w-full justify-start bg-gradient-to-r from-primary to-primary/80"
                onClick={handleBookingClick}
              >
                Maak je reservering
              </Button>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
